import React, { useState } from 'react';
import DomainList from '../components/DomainList';
import DNSManager from '../components/DNSManager';
import HealthDashboard from '../components/HealthDashboard';
import VPSMonitor from '../components/VPSMonitor';
import Analytics from '../components/Analytics';
import ExternalDashboards from '../components/ExternalDashboards';
import AgentWorkspace from '../components/AgentWorkspace';
import '../styles/Dashboard.css';

function Dashboard({ onLogout }) {
  const [activeTab, setActiveTab] = useState('domains');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="dashboard-container">
      <nav className="navbar">
        <div className="navbar-brand">
          <h1>FIRMA Dashboard</h1>
        </div>
        <div className="navbar-menu">
          <div className="navbar-tabs">
            <button
              className={`nav-tab ${activeTab === 'domains' ? 'active' : ''}`}
              onClick={() => setActiveTab('domains')}
            >
              Domains
            </button>
            <button
              className={`nav-tab ${activeTab === 'dns' ? 'active' : ''}`}
              onClick={() => setActiveTab('dns')}
            >
              DNS
            </button>
            <button
              className={`nav-tab ${activeTab === 'health' ? 'active' : ''}`}
              onClick={() => setActiveTab('health')}
            >
              Health
            </button>
            <button
              className={`nav-tab ${activeTab === 'vps' ? 'active' : ''}`}
              onClick={() => setActiveTab('vps')}
            >
              VPS
            </button>
            <button
              className={`nav-tab ${activeTab === 'analytics' ? 'active' : ''}`}
              onClick={() => setActiveTab('analytics')}
            >
              Analytics
            </button>
            <button
              className={`nav-tab ${activeTab === 'dashboards' ? 'active' : ''}`}
              onClick={() => setActiveTab('dashboards')}
            >
              Dashboards
            </button>
            <button
              className={`nav-tab ${activeTab === 'agents' ? 'active' : ''}`}
              onClick={() => setActiveTab('agents')}
            >
              Agents
            </button>
          </div>
          <div className="navbar-actions">
            <a
              href="https://console.hetzner.cloud"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-external"
              title="Hetzner Console"
            >
              🖥️ Hetzner
            </a>
            <a
              href="https://dokploy.zmcor.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-external"
              title="Dokploy Dashboard"
            >
              🚀 Dokploy
            </a>
            <button className="btn-refresh" onClick={handleRefresh} title="Refresh">
              🔄
            </button>
            <button className="btn-logout" onClick={onLogout}>
              Logout
            </button>
          </div>
        </div>
      </nav>

      <div className="dashboard-content">
        {activeTab === 'domains' && <DomainList key={refreshKey} />}
        {activeTab === 'dns' && <DNSManager key={refreshKey} />}
        {activeTab === 'health' && <HealthDashboard key={refreshKey} />}
        {activeTab === 'vps' && <VPSMonitor key={refreshKey} />}
        {activeTab === 'analytics' && <Analytics key={refreshKey} />}
        {activeTab === 'dashboards' && <ExternalDashboards key={refreshKey} />}
        {activeTab === 'agents' && <AgentWorkspace key={refreshKey} />}
      </div>
    </div>
  );
}

export default Dashboard;
